import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { ShipmentForm } from "@/components/admin/ShipmentForm";
import { PageTitle } from "@/components/admin/AdminLayout";

export default function ShipmentNew() {
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const submit = async (payload) => {
    setBusy(true);
    try {
      const { data } = await api.post("/admin/shipments", payload);
      toast.success(`Spedizione creata: ${data.code}`);
      navigate(`/admin/spedizioni/${data.code}?nuova=1`);
    } catch (e) {
      toast.error(formatApiError(e));
      setBusy(false);
    }
  };
  return (
    <div className="max-w-4xl" data-testid="admin-shipment-new">
      <PageTitle title="Nuova spedizione" subtitle="Al salvataggio il sistema genera automaticamente un codice tracking univoco." />
      <ShipmentForm onSubmit={submit} submitting={busy} mode="create" />
    </div>
  );
}
